import styled from "styled-components";
import { useTranslation } from "@pancakeswap/localization";
import { ChevronDownIcon } from "../../../../components/Svg";
import { useMatchBreakpoints } from "../../../../contexts";

interface DetailsProps {
   children?: import('react').ReactNode; actionPanelToggled: boolean;
}

const Container = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding-right: 8px;
  color: ${({ theme }) => theme.colors.primary};

  ${({ theme }) => theme.mediaQueries.sm} {
    padding-right: 0px;
  }
`;

const ArrowIcon = styled(ChevronDownIcon)<{ children?: import('react').ReactNode; toggled: boolean }>`
  transform: ${({ toggled }) => (toggled ? "rotate(180deg)" : "rotate(0)")};
  height: 20px;
`;

const Details: React.FC<React.PropsWithChildren<DetailsProps>> = ({ actionPanelToggled }) => {
  const { t } = useTranslation();
  const { isDesktop } = useMatchBreakpoints();

  return (
    <Container>
      {!isDesktop && t("Details")}
      <ArrowIcon aria-label={t("Toggle details")} color="primary" toggled={actionPanelToggled} />
    </Container>
  );
};

export default Details;
